import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/articles';

export default function ArticlesSection() {
  return (
    <section id="articles" className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-4">
            Buying Guides
          </span>
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-foreground-950">
            Latest AllChinaBuy Spreadsheet Guides
          </h2>
          <p className="mt-3 text-foreground-600 text-base max-w-xl">
            Expert-written guides to help you navigate the AllChinaBuy Spreadsheet, find trusted sellers, and shop with confidence. 12 comprehensive articles covering everything you need.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group block rounded-xl border border-background-200 bg-background-50 overflow-hidden hover:border-primary-300 transition-all cursor-pointer"
            >
              <div className="w-full h-44 md:h-48 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950 group-hover:text-primary-600 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="mt-3 flex items-center gap-2 text-primary-500 text-xs md:text-sm font-medium">
                  <span>Read Guide</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <p className="text-sm text-foreground-400">
            More guides added regularly — check back for the latest AllChinaBuy Spreadsheet tips and seller updates.
          </p>
        </div>
      </div>
    </section>
  );
}